import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { NotifierService } from 'angular-notifier';
import { BoobleModalService } from 'booble-modal';
import { GenericBottomSheetComponent } from 'src/app/shared/components/generic-bottom-sheet/generic-bottom-sheet.component';
import { AuthenticationService } from 'src/app/shared/services';
import { BankAccountService } from 'src/app/shared/services/bank-account.service';
import { OrdersService } from 'src/app/shared/services/orders.service';

@Component({
  selector: 'app-remove-contact-confirm',
  templateUrl: './remove-contact-confirm.component.html',
  styleUrls: ['./remove-contact-confirm.component.scss'],
})
export class RemoveContactConfirmComponent implements OnInit {
  boobleModalData: number;
  loading: boolean;
  private readonly notifier: NotifierService;
  isMobile: boolean;

  @ViewChild('bottomSheetContent') bottomSheetContent: TemplateRef<any>;

  constructor(
    private modalService: BoobleModalService,
    notifierService: NotifierService,
    private readonly orderService: OrdersService,
    private readonly accountService: AuthenticationService,
    private bottomSheet: MatBottomSheet,
    private readonly bankAccountService: BankAccountService
  ) {
    this.notifier = notifierService;
  }

  get companyId() {
    return +this.accountService.getCompanyId();
  }

  ngOnInit() {
    this.isMobile = window.innerWidth <= 820;
  }

  openBottomSheet() {
    this.bottomSheet.open(GenericBottomSheetComponent, {
      data: { content: this.bottomSheetContent },
    });
  }

  closeModal() {
    this.modalService.dismiss(null);
  }

  confirm(bankAccountId: number) {
    this.loading = true;

    this.bankAccountService.deleteAccount(bankAccountId).subscribe({
      next: (accountResult) => {
        this.loading = false;
        this.bankAccountService.updateBankAccountsView();
        this.notifier.notify('success', 'Contato excluído com sucesso.');
        this.closeModal();
      },
      error: (err) => {
        this.loading = false;
      },
    });
  }
}
